import { Fragment, useState, useRef, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo.svg';
import Hero3 from './Main';

const BoardWrite = () => {
    const navigate = useNavigate();
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(false);
    const quillRef = useRef(null);

    // 이미지 업로드 핸들러
    const imageHandler = () => {
        const input = document.createElement('input');
        input.setAttribute('type', 'file');
        input.setAttribute('accept', 'image/jpeg,image/png,image/gif,image/webp');
        input.click();

        input.onchange = async () => {
            const file = input.files[0];
            if (!file) return;

            // 파일 크기 검증 (5MB)
            if (file.size > 5 * 1024 * 1024) {
                alert('파일 크기는 5MB를 초과할 수 없습니다.');
                return;
            }

            try {
                const formData = new FormData();
                formData.append('image', file);
                formData.append('folder', 'board-images');

                const response = await fetch('/api/upload-image.php', {
                    method: 'POST',
                    body: formData,
                });

                const result = await response.json();

                if (result.success) {
                    const editor = quillRef.current.getEditor();
                    const range = editor.getSelection(true);
                    const imageUrl = `https://mrlo.co.kr${result.url}`;
                    editor.insertEmbed(range.index, 'image', imageUrl);
                    editor.setSelection(range.index + 1);
                } else {
                    alert(result.message || '이미지 업로드에 실패했습니다.');
                }
            } catch (err) {
                alert('이미지 업로드 중 오류가 발생했습니다.');
                console.error('Image upload error:', err);
            }
        };
    };

    // Quill 모듈 설정
    const modules = useMemo(() => ({
        toolbar: {
            container: [
                [{ 'header': [1, 2, 3, false] }],
                ['bold', 'italic', 'underline', 'strike'],
                [{ 'color': [] }, { 'background': [] }],
                [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                [{ 'align': [] }],
                ['link', 'image'],
                ['clean']
            ],
            handlers: {
                image: imageHandler
            }
        }
    }), []);

    const formats = [
        'header',
        'bold', 'italic', 'underline', 'strike',
        'color', 'background',
        'list', 'bullet',
        'align',
        'link', 'image'
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!title.trim()) {
            alert('제목을 입력해주세요.');
            return;
        }

        // HTML 태그 제거한 순수 텍스트로 내용 체크
        const textContent = content.replace(/<[^>]*>/g, '').trim();
        if (!textContent) {
            alert('내용을 입력해주세요.');
            return;
        }

        try {
            setLoading(true);

            const response = await fetch('/api/create-post.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    title: title,
                    content: content
                })
            });

            const result = await response.json();

            if (result.success) {
                alert('게시글이 작성되었습니다.');
                navigate('/board?admin=true');
            } else {
                alert(result.message || '게시글 작성에 실패했습니다.');
            }
        } catch (err) {
            alert('서버와 통신 중 오류가 발생했습니다.');
            console.error('Error creating post:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        navigate('/board?admin=true');
    };

    return (
        <Fragment>
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <Hero3 />

            <div className="board-write-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="board-write-content">
                                <form onSubmit={handleSubmit} className="board-write-form">
                                    <div className="form-group">
                                        <label htmlFor="title">제목</label>
                                        <input
                                            type="text"
                                            id="title"
                                            name="title"
                                            className="form-control"
                                            value={title}
                                            onChange={(e) => setTitle(e.target.value)}
                                            placeholder="제목을 입력하세요"
                                            required
                                        />
                                    </div>
                                    <div className="form-group" style={{marginTop:"20px"}}>
                                        <label htmlFor="content">내용</label>
                                        <ReactQuill
                                            ref={quillRef}
                                            theme="snow"
                                            value={content}
                                            onChange={setContent}
                                            modules={modules}
                                            formats={formats}
                                            placeholder="내용을 입력하세요"
                                            style={{
                                                height: '400px',
                                                marginBottom: '50px'
                                            }}
                                        />
                                    </div>
                                    <div className="form-buttons" style={{marginTop:"70px", display:"flex", justifyContent:"flex-start"}}>
                                        <button type="submit" className="theme-btn" style={{background:"#0B0056", color:"white", marginRight:"5px"}} disabled={loading}>
                                            {loading ? '등록 중...' : '등록'}
                                        </button>
                                        <button type="button" className="theme-btn btn-cancel" style={{background:"#0B0056", color:"white"}} onClick={handleCancel} disabled={loading}>
                                            취소
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer hclass={'footer-section section-padding'} />
            <Scrollbar />
        </Fragment>
    );
};

export default BoardWrite;
